<template>
    <div id="ScheduleReportList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Schedule Report List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <!-- Button for Clear Cache -->
                    <div class="web-action-btn">
                      <div class="btn-groups text-right">
                          <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                              <i class="fp-export"></i> Export
                          </a>
                          <router-link v-if="canAdd == true" class="btn btn-primary" v-bind:to="{name: 'ScheduleReportCreate'}" > <i class="fp-add"> </i> Add</router-link>

                      </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content schedule-report-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'listScheduleReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchRun" class="alert-success p-2" id="processFetchBatchMsg">Sending of file is in process. batch no. is {{batchNo}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchRun = 0"> Click Here</router-link> to check file status!</p>
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'listScheduleReport'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listScheduleReportTable"
                                      mode="remote"
                                      title="Schedule Report"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: schedule_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <router-link title="Edit Schedule Report" v-if="canUpdate" class="fp-edit" v-bind:to="{name: 'ScheduleReportEdit',params:{id:props.row.id}}"></router-link>
                                                  <a href="javascript:void(0)" class="btn btn-primary" v-on:click="runNow(props.row.id)">
                                                       Run Now
                                                  </a>
                                              </div>
                                              <div v-if="props.column.field == 'asset_unit_no'">
                                                  <router-link title="View Asset" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'AssetView',params:{id:props.row.asset_id},query:{from:'feature'}}">{{props.row.asset_unit_no}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button v-if="schedule_value  == true" id="deleteScheduleReportBtn" v-on:click.prevent="ScheduleReportDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ScheduleReportList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Schedule Report List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Label',
                    field: 'label',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Label.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Report',
                    field: 'report_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Report Name.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: 'Frequency',
                    field: 'frequency',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Attachment Format", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Daily','Weekly','Monthly'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Last Trigger',
                    field: 'last_trigger',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Next Trigger',
                    field: 'next_trigger',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Attachment',
                    field: 'attachment_format',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Attachment Format", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['PDF','Excel','CSV'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Enabled',
                    field: 'enabled',
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Enabled", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            schedule_value: false,
            loading:false,
            action:'list',
            canAdd:false,
            canUpdate:false,
            pageKey:"_schedule_report_list_",
            batchProcess:0,
            batchNum:"",
            batchRun:0,
            batchNo:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_schedule_report') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_schedule_report') {
                            self.schedule_value = true;
                            self.canAdd = true;
                        }
                        if (permissions[i].name == 'delete_schedule_report') {
                            self.canUpdate = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listScheduleReportTable.unselectAllInternal();
            },

            // exportReports: function() {
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },

            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadList() {
                var self = this;
                var data = this.$refs['listScheduleReportTable'].selectedRows;
                var selectedRows = [];

                for (var i = 0; i < data.length; i++) {
                    selectedRows.push(self.$refs['listScheduleReportTable'].selectedRows[i].id)
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    all:self.serverParams.selectedAll,
                    selectedRows:selectedRows,
                    action:self.action,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/schedule-report/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "delete" ) {

                                self.action = "list";
                                $("#deleteScheduleReportBtn").val("Delete");

                                self.$refs.filterComponent.clearSelectAll();
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection

                            } else if (self.action == "export" ||  self.action == "export_queue") {

                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    if ( self.action == "export" ) {

                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }

                                }

                              self.action = "list";
                              self.loadList();

                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                        // }else{
                        //     self.rows = data.content.row;
                        //     self.totalRecords = data.content.totalRecords;
                        //     self.filteredFlag = false;
                        // }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if ( self.action == "delete" ) {
                            self.generateStatusCodeMessage(jqXHR, true, 'schdeule-report-delete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR, false, 'schdeule-report-laod-list')
                        }
                    }
                });
            },
            runNow(id) {
              
                var self = this;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/schedule-report-run",
                    type: "POST",
                    data: {id: id},
                    headers: this.ajxHeaders,
                    dataType: 'json',
                    success: function (data) {
                        self.loading = false;
                        if (data.code == '200') {
                            self.batchRun = 1;
                            self.batchNo = data.content;
                            self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'schedule-report-run')
                    }
                });
            },

            ScheduleReportDelete() {
              var self = this;
              self.$swal({
                    title: 'Are you sure that you want to delete this Schedule Report?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      self.action = "delete";
                      $("#deleteScheduleReportBtn").val("Deleting ...");
                      self.loadList();

                    } else {
                      console.log("no");
                    }
                });

                // if (confirm('Are you sure that you want to delete this Schedule Report?')) {
                // }

            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/ScheduleReportList.vue